import { render, staticRenderFns } from "./AccountEmvTap.vue?vue&type=template&id=e38c4d80&"
import script from "./AccountEmvTap.vue?vue&type=script&lang=js&"
export * from "./AccountEmvTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports